import classNames from "classnames";
import { Preview } from "components/PreviewModal";
import ToolTip from "components/design/toolTip";
import { useModal } from "hooks/useModal";
import { ReactNode } from "react";
import { FileObject } from "types/Models/fileObject";
import { FileIcon } from "components/design/FileIcon";

const sizeTypeMap = {
  small: "20",
  medium: "24",
  large: "28",
};

export const FilePreviewTag = ({
  file,
  children,
  block,
  size = "medium",
  className,
}: {
  file: Pick<FileObject, "name" | "uuid" | "file_type" | "is_previewable">;
  children?: ReactNode;
  block?: boolean;
  size?: "small" | "medium" | "large";
  className?: string;
}) => {
  const { open, close, isOpen } = useModal();

  return (
    <>
      <div
        role="button"
        className={classNames(
          "t-inline-flex t-items-center t-gap-2 t-rounded-md t-border t-border-solid t-border-neutral-10 t-p-1.5 t-justify-between",
          {
            "t-w-full": block,
            "t-text-body-sm": size === "small",
          },
          className || ""
        )}
        onClick={open}
      >
        <ToolTip
          text={<div className="t-max-w-40 t-break-words">{file.name}</div>}
        >
          <div
            className={classNames(
              "t-flex t-items-center t-gap-1 t-max-w-full",
              {
                "t-flex-1 t-min-w-0": block,
              }
            )}
          >
            <FileIcon
              fileType={file.file_type}
              size={sizeTypeMap[size]}
              className="t-shrink-0"
            />
            <div
              className={classNames("t-flex-1 t-truncate", {
                "t-min-w-0": block,
                "t-max-w-32": !block,
              })}
            >
              {file.name}
            </div>
          </div>
        </ToolTip>
        {children}
      </div>
      <Preview showModal={isOpen} closeModal={close} previewId={file.uuid} />
    </>
  );
};
